require('./dependencies.js');
require('./main.scss');

// Require all js files in /js
function requireAll(r) { r.keys().forEach(r); }
requireAll(require.context('./js/', true, /(?<!\.min)\.js$/));